export default "__VITE_ASSET__CtYmeef7__"